/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-types */
import {
  Button,
  Form,
  FormInstance,
  Input,
  Pagination,
  Popover,
  Row,
  Table,
  TableColumnType,
  TableProps,
} from 'antd'
import { Rule } from 'antd/lib/form'
import { useForm } from 'antd/lib/form/Form'
import { GetRowKey } from 'rc-table/lib/interface'
import React, {
  ReactElement,
  useContext,
  useEffect,
  useRef,
  useState,
} from 'react'
import { useSelector } from 'react-redux'
import { ItemCompletionType } from '../../features/completion/completionSlice'
import {
  RecipeItemFieldInput,
  RecipeItemFieldInputRef,
} from '../../features/treatment/editor/components/RecipeItemFieldInput'
import {
  RecipeItemInput,
  RecipeItemInputRef,
} from '../../features/treatment/editor/components/RecipeItemInput'
import ArrowDownCircleFill from '../../compnents/icons/svg/filled/arrowDownCircleFill.svg'
import { selectRecipe } from '../../features/treatment/editor/recipeEditorSlice'
import { Material } from '../../models/material'
import { Page } from '../../models/page'
import styles from './EditableList.module.css'

declare module 'react' {
  function forwardRef<A, B>(
    Component: (props: A) => B
  ): (props: A) => ReactElement | null
}

interface EditableListContextData {
  form?: FormInstance<any>
  refs: Record<string, React.RefObject<HTMLDivElement>>
  rowIndex?: number
  tableRef?: React.RefObject<any>
}

interface OtherRecordType {
  billingCategory?: any
  id?: any
  uniqueId?: any
  normalDose?: any
}

const EditableListContext = React.createContext<EditableListContextData>({
  refs: {},
})

export interface EditableColumnType<RecordType extends object>
  extends TableColumnType<RecordType> {
  editable?: boolean | ((r: RecordType) => boolean);
  autoFocus?: boolean | ((r: RecordType) => boolean);
  nextDataIndex?: string;
  invoiceNbSynchronization?: boolean;
  inputType?:
  | "text"
  | "material"
  | "accountUnit"
  | "normalFrequency"
  | "normalUsemethod"
  | "doseUnit"
  | "invoiceNb"
  | "realCount"
  | "realSplitCount"
  completionType?: ItemCompletionType;
  rules?: Rule[] | ((record: RecordType) => Rule[]);
  storehouseId?: string;
  normalGysName?: any;
  editor?: React.ReactNode;
  recipeCategory?: any;
  dataList?: any[];
  placeholder?: string;
  receiptsType?: number;
  storehouseCategory?: any;
  storehouseTag?: number;
  isShowAddcatalog?: boolean
  msfxFlag?: any
  BScategory?: any; //报损标志 9
  categoryTag?: any; // 7 领用出库
  saveOnBlur?: boolean;
  onInputChange?: (record: RecordType, value: string) => void;
  onSave?: (record: RecordType, values: any, invoiceNbSFlag?: any) => void;
  onSelectMaterial?: (record: RecordType, material: Material) => void;
  children?: any[];
  onHeaderCell?: any
}

interface EditableCellProps<RecordType extends object>
  extends React.HTMLAttributes<HTMLElement> {
  editable: boolean
  autoFocus: boolean | ((r: RecordType) => boolean)
  nextDataIndex?: string
  invoiceNbSynchronization?: boolean
  inputType?:
  | 'text'
  | 'material'
  | 'accountUnit'
  | 'normalFrequency'
  | 'normalUsemethod'
  | 'doseUnit'
  | 'invoiceNb'
  | 'realCount'
  | 'realSplitCount'
  completionType?: ItemCompletionType
  rules?: Rule[] | ((record: RecordType & OtherRecordType) => Rule[])
  storehouseId?: string
  normalGysName?: any
  dataIndex: string
  record: RecordType & OtherRecordType
  children: React.ReactNode
  recipeCategory?: any
  BScategory?: any
  categoryTag?: any
  dataList?: any[]
  placeholder?: string
  receiptsType?: any;
  storehouseCategory?: any
  storehouseTag?: number
  isShowAddcatalog?: boolean
  msfxFlag?: any
  saveOnBlur?: boolean
  onInputChange?: (record: RecordType, value: string) => void
  onSave?: (record: RecordType, values: any, invoiceNbSFlag?: any) => void
  onSelectMaterial?: (record: RecordType, material: Material) => void
  onSelectParam?: (record: RecordType, values: any) => void
}

const EditableRow = (props: any): ReactElement => {
  const [form] = useForm()
  const { index, tableRef, ...restProps } = props

  return (
    <Form form={form} component={false} autoComplete='off'>
      <EditableListContext.Provider
        value={{
          form,
          refs: {},
          rowIndex: index,
          tableRef,
        }}
      >
        <tr {...restProps} />
      </EditableListContext.Provider>
    </Form>
  )
}

function EditableCell<RecordType extends object>({
  editable,
  autoFocus,
  nextDataIndex,
  inputType,
  invoiceNbSynchronization,
  recipeCategory,
  completionType,
  rules,
  storehouseId,
  normalGysName,
  receiptsType,
  dataIndex,
  record,
  children,
  BScategory,
  categoryTag,
  placeholder,
  dataList,
  storehouseCategory,
  storehouseTag,
  isShowAddcatalog,
  msfxFlag,
  saveOnBlur = true,
  onInputChange,
  onSave,
  onSelectMaterial,
  onSelectParam,
  ...others
}: EditableCellProps<RecordType>): ReactElement {
  const context = useContext(EditableListContext)

  const wrapperRef = useRef<HTMLDivElement>(null)

  const inputRef = useRef<Input>(null)

  const invoiceNbInputRef = useRef<Input>(null)

  const itemRef = useRef<RecipeItemInputRef>(null)

  const accountUnitInputRef = useRef<RecipeItemFieldInputRef>(null)

  const normalFrequencyInputRef = useRef<RecipeItemFieldInputRef>(null)

  const normalUsemethodInputRef = useRef<RecipeItemFieldInputRef>(null)

  const doseUnitInputRef = useRef<RecipeItemFieldInputRef>(null)

  const [visible, setVisible] = useState(false)

  const [invoiceNbValue, setInvoiceNbValue] = useState<string>('')

  const [isDoseUnitShiLiang, setIsDoseUnitShiLiang] = useState(false) // 剂量单位是否为"适量"

  const recipe = useSelector(selectRecipe)

  const effectiveRules = rules instanceof Function ? rules(record) : rules

  const refs = context.refs

  if (editable && dataIndex) {
    refs[dataIndex] = wrapperRef
  }

  const [isEditing, setIsEditing] = useState(
    autoFocus instanceof Function ? autoFocus(record) : !!autoFocus
  )

  let isTbEdit = false

  let flag = false

  const savingRef = useRef(false)

  useEffect(() => {
    if (isEditing) {
      inputRef.current?.focus()
      itemRef.current?.focus()
      inputRef.current?.select()
      itemRef.current?.select()
      invoiceNbInputRef.current?.select()
      invoiceNbInputRef.current?.focus()
      accountUnitInputRef.current?.select()
      accountUnitInputRef.current?.focus()
      normalFrequencyInputRef.current?.select()
      normalFrequencyInputRef.current?.focus()
      normalUsemethodInputRef.current?.select()
      normalUsemethodInputRef.current?.focus()
      doseUnitInputRef.current?.select()
      doseUnitInputRef.current?.focus()
      // 进入编辑时，检查剂量单位是否为"适量"
      if ((record as any)?.doseUnit === '适量') {
        setIsDoseUnitShiLiang(true)
      } else {
        setIsDoseUnitShiLiang(false)
      }
    }
  }, [isEditing])

  // 当记录的剂量单位变化时，同步更新置灰状态
  useEffect(() => {
    const doseUnit = (record as any)?.doseUnit
    setIsDoseUnitShiLiang(doseUnit === '适量')
  }, [(record as any)?.doseUnit])

  useEffect(() => {
    if (isEditing && inputType == "invoiceNb") {
      const initialValue = (record as any)[dataIndex] || ''
      if (invoiceNbValue !== initialValue) {
        setInvoiceNbValue(initialValue)
      }
      context?.form?.setFieldsValue({ [dataIndex]: initialValue })
    }
  }, [isEditing, dataIndex, inputType])

  const toggle = () => {
    const newIsEditing = !isEditing
    setIsEditing(newIsEditing)
    // 只在进入编辑时初始化表单值，退出时不重置，避免 300ms 延迟的 onBlur saveSync 读到被重置的旧值
    if (newIsEditing) {
      const initialValue = (record as any)[dataIndex] || ''
      context?.form?.setFieldsValue({ [dataIndex]: initialValue })
      if (inputType == "invoiceNb") {
        setInvoiceNbValue(initialValue)
      }
    }
  }

  const getSaveValues = (values: any) => {
    const doseUnit =
      inputType === 'doseUnit'
        ? values?.[dataIndex] ?? context?.form?.getFieldValue(dataIndex)
        : undefined

    if (doseUnit === '适量') {
      return {
        ...values,
        normalDose: -1,
      }
    }

    return values
  }

  // 同步版本的 save，用于 onBlur 场景确保在事件冒泡前完成数据提交
  const saveSync = (moveToNext: boolean, invoiceNbSFlag?: any) => {
    if (savingRef.current) return
    savingRef.current = true
    const values = getSaveValues(context?.form?.getFieldsValue())
    const errors = context?.form?.getFieldError(dataIndex)
    if (errors && errors.length > 0) {
      savingRef.current = false
      return
    }

    const invoiceNb = context?.form?.getFieldValue('invoiceNb') || values.invoiceNb

    toggle()
    const normalDose = values?.normalDose || record?.normalDose
    onSave && onSave({ ...record, normalDose: values?.doseUnit == '适量' ? -1 : normalDose, tbEdit: isTbEdit }, { ...values, normalDose: values?.doseUnit == '适量' ? -1 : normalDose, invoiceNb: invoiceNb }, invoiceNbSFlag);
    isTbEdit = false
    if (moveToNext && nextDataIndex) {
      const nextRef = refs[nextDataIndex]
      nextRef?.current?.click()
    }
    savingRef.current = false
  }
  const save = async (moveToNext: boolean, invoiceNbSFlag?: any) => {
    if (savingRef.current) return
    savingRef.current = true
    try {
      let values
      try {
        values = await context?.form?.validateFields()
      } catch (e) {
        values = context?.form?.getFieldsValue()
        const errors = context?.form?.getFieldError(dataIndex)
        if (errors && errors.length > 0) {
          return
        }
        values = { [dataIndex]: values[dataIndex] }
      }

      // 直接从 Form 获取值，这是最可靠的方式
      values = getSaveValues(values)
      const invoiceNb = context?.form?.getFieldValue('invoiceNb') || values.invoiceNb
      toggle()
      const normalDose = values?.normalDose || record?.normalDose
      onSave && onSave({ ...record, normalDose: values?.doseUnit == '适量' ? -1 : normalDose, tbEdit: isTbEdit }, { ...values, normalDose: values?.doseUnit == '适量' ? -1 : normalDose, invoiceNb: invoiceNb }, invoiceNbSFlag);
      
      isTbEdit = false
      if (moveToNext && nextDataIndex) {
        const nextRef = refs[nextDataIndex]
        nextRef?.current?.click()
      }
    } catch (e) {
      // do nothing.
    } finally {
      savingRef.current = false
    }
  }

  return (
    <td {...others}>
      {editable ? (
        (
          recipe?.category == 3
            ? isEditing && record?.billingCategory !== "97"
            : isEditing
        ) ? (
          <>
            <Form.Item
              style={{ margin: 0 }}
              name={dataIndex}
              className={msfxFlag ? styles.msfxInput : styles.input}
              rules={effectiveRules}
            >
              {inputType === "material" && completionType ? (
                <RecipeItemInput
                  record={record}
                  ref={itemRef}
                  BScategory={BScategory}
                  categoryTag={categoryTag}
                  storehouseCategory={storehouseCategory}
                  isShowAddcatalog={isShowAddcatalog}
                  msfxFlag={msfxFlag}
                  placeholder={placeholder}
                  type={completionType}
                  storehouseId={storehouseId}
                  normalGysName={normalGysName}
                  receiptsType={receiptsType}
                  filters={false}
                  useSpecifiedBatch={true}
                  onSelect={(m) => {
                    toggle();
                    onSelectMaterial && onSelectMaterial(record, m);
                  }}
                  onPressEnter={() => {
                    setTimeout(() => {
                      if (nextDataIndex) {
                        const nextRef = refs[nextDataIndex];
                        nextRef?.current?.click();
                      }
                    }, 100)
                  }}
                  scene={"InputToReturn"}
                  disablePatientPhone
                />
              ) : inputType == "accountUnit" ||
                inputType == "normalFrequency" ||
                inputType == "normalUsemethod" ||
                inputType == "doseUnit" ? (
                <RecipeItemFieldInput
                  yzcfkf={inputType == 'doseUnit' || inputType == 'accountUnit' ? true : false} //列表编辑剂量单位的标志(展示方式跟别的单位不一样)
                  editTableDoseUnit={inputType == 'doseUnit' || inputType == 'accountUnit' ? true : false}
                  recipeCategory={recipeCategory}
                  placeholderInput={placeholder}
                  ref={
                    inputType == "accountUnit"
                      ? accountUnitInputRef
                      : inputType == "normalFrequency"
                        ? normalFrequencyInputRef
                        : inputType == "normalUsemethod"
                          ? normalUsemethodInputRef
                          : doseUnitInputRef
                  }
                  field={inputType}
                  isTbEdit={true}
                  noSize
                  onChange={(values, pc: any) => {
                    localStorage.setItem("calc", pc || 0);
                    // 剂量单位为"适量"时，清空剂量并置灰
                    if (inputType === 'doseUnit') {
                      if (values === '适量') {
                        setIsDoseUnitShiLiang(true)
                        context?.form?.setFieldsValue({ normalDose: '' })
                      } else {
                        setIsDoseUnitShiLiang(false)
                      }
                    }
                  }}
                  onBlur={(values: any) => {
                    save && save(true);
                  }}
                  record={record}
                  onChangeAll={() => {
                    isTbEdit = true;
                  }}
                  onPressEnter={() => {
                    if (nextDataIndex) {
                      const nextRef = refs[nextDataIndex];
                      nextRef?.current?.click();
                    }
                  }}
                />
                ) : inputType == "invoiceNb" ?
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    <Input
                      style={{ width: '80px' }}
                      ref={invoiceNbInputRef}
                      placeholder={placeholder}
                      value={invoiceNbValue}
                      onPressEnter={() => {
                        if (storehouseTag && storehouseTag > 0) {
                          // 已登账：回车跳到下一行发票号
                          setTimeout(async () => {
                            // 1. 保存当前行
                            save(false, flag);

                            // 2. 获取当前行索引
                            const currentIndex = dataList?.findIndex((item: any) => item.id === record?.id);
                            if (currentIndex === -1 || currentIndex === undefined) return;

                            // 3. 下一行
                            const nextIndex = currentIndex + 1;
                            const length = dataList?.length || 0;

                            if (nextIndex < length) {
                              // 模拟点击下一行的 invoiceNb 单元格，进入编辑
                              setTimeout(() => {
                                const nextRowKey = dataList?.[nextIndex]?.id;
                                const nextRowEl = document.querySelector(`tr[data-row-key="${nextRowKey}"]`);

                                const nextCell = nextRowEl?.querySelector(`div[data-field="invoiceNb"]`) as HTMLDivElement;

                                if (nextCell) nextCell.click();
                              }, 100);
                            }
                          }, 300);
                        } else {
                          // 未登账：回车跳到右边生产日期
                          save(true);
                        }
                      }}
                      onChange={(e) => {
                        const newValue = e.target.value
                        setInvoiceNbValue(newValue)
                        context?.form?.setFieldsValue({ [dataIndex]: newValue })
                      }}
                      onFocus={() => {
                        if (invoiceNbSynchronization) {
                          setVisible(true);
                        } else {
                          setVisible(false);
                        }
                      }}
                      onKeyDown={(e) => {
                        if (e.key !== "Tab") {
                          return;
                        }
                        e.stopPropagation();
                        e.preventDefault();
                        save(true);
                      }}
                      onBlur={() => {
                        setTimeout(() => {
                          saveSync(false, flag);
                        }, 300);
                      }}
                    />

                    <Popover
                      content={<><div>
                        向下同步发票号
                      </div>
                      </>
                      }
                      placement="top"
                      trigger="hover">
                      <img
                        src={ArrowDownCircleFill}
                        style={{ width: '30px', height: '30px', marginLeft: '6px' }}
                        alt=""
                        onClick={(() => {
                          flag = true
                        })} />
                    </Popover>
                  </div>
                  :
                  //  inputType == "realSplitCount" || inputType == "realCount" ? (
                  //   <Input
                  //     ref={inputRef}
                  //     placeholder={placeholder}
                  //     onFocus={() => {
                  //       if (invoiceNbSynchronization) {
                  //         setVisible(true);
                  //       } else {
                  //         setVisible(false);
                  //       }
                  //     }}
                  //     onKeyDown={(e) => {
                  //       if (e.key !== "Tab") {
                  //         return;
                  //       }
                  //       e.stopPropagation();
                  //       e.preventDefault();
                  //       save(true);
                  //     }}
                  //     onBlur={() => {
                  //       saveSync(false, flag);
                  //     }}
                  //     onPressEnter={() => {
                  //       if (inputType == 'realSplitCount') {
                  //         // 实际拆零数回车 → 跳转到同行的实际数
                  //         setTimeout(() => {
                  //           save(false)
                  //           const rowKey = record?.uniqueId || record?.id;
                  //           const rowEl = document.querySelector(`tr[data-row-key="${rowKey}"]`);
                  //           const nextCell = rowEl?.querySelector(`div[data-field="realCount"]`) as HTMLDivElement;
                  //           if (nextCell) nextCell.click();
                  //           console.log(inputType, "nextCellnextCell")
                  //         }, 300);
                  //       } else if (inputType == 'realCount') {
                  //         // 实际数回车 → 下一行（可拆零跳实际拆零数，不可拆零跳实际数）
                  //         setTimeout(() => {
                  //           save(false)
                  //           const currentIndex = dataList?.findIndex((item: any) => item.uniqueId == record?.uniqueId);
                  //           if (currentIndex === -1 || currentIndex === undefined) return;
                  //           const nextIndex = currentIndex + 1;
                  //           const length = dataList?.length || 0;
                  //           if (nextIndex < length) {
                  //             const nextRow = dataList?.[nextIndex];
                  //             // 下一行可拆零 → 实际拆零数，不可拆零 → 实际数
                  //             const targetField = nextRow?.splitTag === 1 ? 'realSplitCount' : 'realCount';
                  //             setTimeout(() => {
                  //               const nextRowKey = dataList?.[nextIndex]?.uniqueId;
                  //               const nextRowEl = document.querySelector(`tr[data-row-key="${nextRowKey}"]`);
                  //               const nextCell = nextRowEl?.querySelector(`div[data-field="${targetField}"]`) as HTMLDivElement;
                  //               if (nextCell) nextCell.click();
                  //               console.log(inputType, "nextCellnextCell")
                  //             }, 100);
                  //           } else {
                  //             toggle()
                  //             return
                  //           }
                  //           console.log(inputType, "nextCellnextCell")
                  //         }, 300);
                  //       }
                  //     }}
                  //   />
                  // ) :
                   <Input
                    ref={inputRef}
                    placeholder={placeholder}
                    onChange={(e) => {
                      onInputChange && onInputChange(record, e.target.value)
                    }}
                    onPressEnter={() => save(true)}
                    onFocus={() => {
                      if (invoiceNbSynchronization) {
                        setVisible(true);
                      } else {
                        setVisible(false);
                      }
                    }}
                    onKeyDown={(e) => {
                      if (e.key !== "Tab") {
                        return;
                      }
                      e.stopPropagation();
                      e.preventDefault();
                      save(true);
                    }}
                    onBlur={() => {
                      if (saveOnBlur) {
                        setTimeout(() => {
                          save(false, flag);
                        }, 300);
                      }
                    }}
                  />}
              </Form.Item>
            </>
        ) : (
          msfxFlag ?
            <div ref={wrapperRef} onClick={toggle} className={styles.msfxwrappers} data-field={dataIndex}>
              {children}
            </div> :
            <div ref={wrapperRef} onClick={toggle} className={styles.wrapper} data-field={dataIndex}>
              {children}
            </div>
        )
      ) : (
        children
      )}
    </td>
  )
}

interface EditableListProp<RecordType extends object>
  extends TableProps<RecordType> {
  ref?: any
  page?: Page<RecordType>
  columns: EditableColumnType<RecordType>[]
  rowKey?: GetRowKey<RecordType>
  pageSizeOptions?: any
  defaultPageSize?: number
  showQuickJumper?: boolean
  showSizeChanger?: boolean
  onChangePage?: (current: number, size?: number) => void
}

export function EditableList<RecordType extends object>({
  ref,
  page,
  pagination = undefined,
  pageSizeOptions = ['10', '20', '50', '100', '500'],
  dataSource,
  onChangePage,
  columns,
  rowKey = (record: RecordType) => (record as any).id || (record as any).uniqueId,
  className,
  defaultPageSize,
  showQuickJumper = true,
  showSizeChanger = true,
  ...others
}: EditableListProp<RecordType>): ReactElement {
  const tableRef = useRef<any>(null)

  const mergedColumns = columns?.map((col: any) => {
    if (!col.editable) {
      return col
    }
    return {
      ...col,
      onCell: (record: RecordType) => ({
        record,
        editable: col.editable instanceof Function ? col.editable(record) : col.editable,
        autoFocus: col.autoFocus,
        nextDataIndex: col.nextDataIndex,
        invoiceNbSynchronization: col.invoiceNbSynchronization,
        inputType: col.inputType,
        completionType: col.completionType,
        rules: col.rules,
        storehouseId: col.storehouseId,
        normalGysName: col?.normalGysName,
        BScategory: col.BScategory,
        categoryTag: col.categoryTag,
        receiptsType: col?.receiptsType,
        placeholder: col.placeholder,
        dataList: col.dataList,
        storehouseCategory: col.storehouseCategory,
        storehouseTag: col.storehouseTag,
        isShowAddcatalog: col.isShowAddcatalog,
        msfxFlag: col.msfxFlag,
        saveOnBlur: col.saveOnBlur,
        onInputChange: col.onInputChange,
        recipeCategory: col.recipeCategory,
        dataIndex: col.dataIndex,
        onSave: col.onSave,
        onSelectMaterial: col.onSelectMaterial,
      }),
    } as EditableColumnType<RecordType>
  })

  return (
    <>
      <Table<RecordType>
        ref={tableRef}
        components={{
          body: {
            row: EditableRow,
            cell: EditableCell,
          },
        }}
        // scroll={{ y: 'auto' }}
        // sticky
        dataSource={page ? page.items : dataSource}
        columns={mergedColumns}
        rowKey={rowKey}
        pagination={false}
        {...others}
        className={`${className || ''} ${styles.table}`}
      />
      {page && pagination !== false && (
        <Row
          justify='end'
          align='middle'
          style={{
            height: '60px',
            padding: '0 15px',
          }}
        >
          <Pagination
            defaultPageSize={defaultPageSize}
            showQuickJumper={showQuickJumper}
            showSizeChanger={showSizeChanger}
            pageSize={page.size < 0 ? 10 : page.size}
            current={page.current}
            total={page.total}
            pageSizeOptions={
              pageSizeOptions
                ? pageSizeOptions
                : ['10', '20', '50', '100', '500']
            }
            onChange={onChangePage}
            className={styles.pagination}
            showTotal={(total) => `共 ${total} 条`}
          />
        </Row>
      )}
    </>
  )
}
